export enum ExpenseType {
	Raw = 'RAW',
	Service = 'SERVICE',
	Transaction = 'TRANSACTION',
	UserProvided = 'USER_PROVIDED',
	Derive = 'DERIVE',
	DerivedFromTransaction = 'DERIVED_FROM_TRANSACTION',
}
